import _defineProperty from "/codebuild/output/src3618121175/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function compactItemVerticalBorder(token, parentCls) {
  return _defineProperty(_defineProperty({}, "&-item:not(".concat(parentCls, "-last-item)"), {
    marginBottom: token.calc(token.lineWidth).mul(-1).equal()
  }), '&-item', {
    '&:hover,&:focus,&:active': {
      zIndex: 2
    },
    '&[disabled]': {
      zIndex: 0
    }
  });
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  return _defineProperty(_defineProperty(_defineProperty({}, "&-item:not(".concat(parentCls, "-first-item):not(").concat(parentCls, "-last-item)"), {
    borderRadius: 0
  }), "&-item".concat(parentCls, "-first-item:not(").concat(parentCls, "-last-item)"), _defineProperty({}, "&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg"), {
    borderEndEndRadius: 0,
    borderEndStartRadius: 0
  })), "&-item".concat(parentCls, "-last-item:not(").concat(parentCls, "-first-item)"), _defineProperty({}, "&, &".concat(prefixCls, "-sm, &").concat(prefixCls, "-lg"), {
    borderStartStartRadius: 0,
    borderStartEndRadius: 0
  }));
}
export function genCompactItemVerticalStyle(token) {
  var compactCls = "".concat(token.componentCls, "-compact-vertical");
  return _defineProperty({}, compactCls, Object.assign(Object.assign({}, compactItemVerticalBorder(token, compactCls)), compactItemBorderVerticalRadius(token.componentCls, compactCls)));
}